import { carouselItems } from '@/mocks/homeData';

export default function Carousel() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            焦点专题
          </h2>
          <div className="mt-4 w-16 h-1 bg-primary-500 mx-auto rounded-full"></div>
          <p className="mt-3 text-sm text-foreground-600">四大核心系列，一站尽览</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <div
              key={item.id}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 transition-all duration-300 hover:border-primary-300/50 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-semibold font-heading text-foreground-900">
                  {item.title}
                </h3>
                <p className="mt-1 text-xs md:text-sm text-primary-500 font-medium">
                  {item.subtitle}
                </p>
                <p className="mt-3 text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}